import { manualRetryResultSchema } from "@redotech/redo-billing-common/manual-retry-result";
import * as z from "zod";

const payBillInput_ = z.object({ billId: z.string() });
export const payBillInput: z.ZodType<PayBillInput> = payBillInput_;
export interface PayBillInput extends z.infer<typeof payBillInput_> {}

// `charge` carries the synchronous Stripe outcome of the collection attempt so
// the UI can report a decline reason; absent only for bills with no payout.
const payBillOutput_ = z.object({ charge: manualRetryResultSchema.optional() });
export const payBillOutput: z.ZodType<PayBillOutput> = payBillOutput_;
export interface PayBillOutput extends z.infer<typeof payBillOutput_> {}

export const payBill = {
  name: "payBill" as const,
  input: payBillInput,
  output: payBillOutput,
};
